import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, DynamicSvg, Typography, getTestId, isLastItem, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { Image, View } from 'react-native';
import { OfferStripWidget } from '../offer-strip-widget';
import { getBenefitWidgetStyles } from './BenefitWidgetStyles';
export var BenefitWidgetComponent = props => {
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var benefitWidgetStyles = getBenefitWidgetStyles(props, isSmallScreen);
  var _props$data = props.data,
    data = _props$data === void 0 ? [] : _props$data,
    offerStripProps = props.offerStripProps,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'BenefitWidget' : _props$testID,
    style = props.style,
    _props$hasCard = props.hasCard,
    hasCard = _props$hasCard === void 0 ? true : _props$hasCard,
    _props$showShadow = props.showShadow,
    showShadow = _props$showShadow === void 0 ? false : _props$showShadow;
  var Container = hasCard ? Card : View;
  return _jsx(_Fragment, {
    children: isValidObject(data) && _jsxs(View, Object.assign({
      style: style
    }, getTestId(testID), {
      children: [_jsx(Container, Object.assign({}, hasCard && {
        showShadow
      }, {
        style: benefitWidgetStyles.container
      }, getTestId(testID, 'benefitCard'), {
        children: data === null || data === void 0 ? void 0 : data.slice(0, 3).map((itemData, index) => {
          return _jsxs(View, Object.assign({
            style: [benefitWidgetStyles.iconButtonContainer]
          }, {
            children: [_jsxs(View, Object.assign({
              style: [benefitWidgetStyles.iconButtonItem]
            }, {
              children: [!!(itemData === null || itemData === void 0 ? void 0 : itemData.iconName) && _jsx(DynamicSvg, Object.assign({
                iconName: itemData === null || itemData === void 0 ? void 0 : itemData.iconName,
                style: benefitWidgetStyles.icon,
                fontSize: isSmallScreen ? 32 : 40
              }, getTestId(testID, 'icon'))), !!(itemData === null || itemData === void 0 ? void 0 : itemData.imageUrl) && _jsx(Image, Object.assign({
                resizeMode: "contain",
                style: benefitWidgetStyles.icon,
                source: {
                  uri: itemData === null || itemData === void 0 ? void 0 : itemData.imageUrl,
                  height: isSmallScreen ? 56 : 72,
                  width: isSmallScreen ? 56 : 72
                }
              }, getTestId(testID, 'logoUrl'))), _jsxs(View, Object.assign({
                style: benefitWidgetStyles.labelTitleContainer
              }, {
                children: [!!(itemData === null || itemData === void 0 ? void 0 : itemData.title) && _jsx(Typography, Object.assign({
                  text: itemData === null || itemData === void 0 ? void 0 : itemData.title,
                  type: "body-para-" + (isSmallScreen ? 'sm' : 'md') + "-bold"
                }, getTestId(testID, 'title'), itemData === null || itemData === void 0 ? void 0 : itemData.titleAccessibilityProps)), !!(itemData === null || itemData === void 0 ? void 0 : itemData.label) && _jsx(Typography, Object.assign({
                  style: benefitWidgetStyles.label,
                  text: itemData === null || itemData === void 0 ? void 0 : itemData.label,
                  type: "body-para-" + (isSmallScreen ? 'xs' : 'sm')
                }, getTestId(testID, 'label'), itemData === null || itemData === void 0 ? void 0 : itemData.labelAccessibilityProps))]
              }))]
            })), !isLastItem(data, index) && _jsx(View, {
              style: benefitWidgetStyles.iconContainerDivider
            })]
          }), "benefit-" + index);
        })
      })), _jsx(OfferStripWidget, Object.assign({}, offerStripProps, {
        variant: "in-card"
      }, getTestId(testID, 'offerStrip')))]
    }))
  });
};
BenefitWidgetComponent.genericRendererKey = 'AirBenefitWidget';